<template>
  <div class="search-type">
    <div :class="getSearchInputPosition" class="search-type-container">
      <TagItem
        v-for="typeItem in typeList"
        :key="typeItem.type"
        :active="currentType === typeItem.type"
        large
        @click="tagOnClick(typeItem)"
      >
        {{ $t(typeItem.name) }}
      </TagItem>
    </div>
  </div>
</template>

<script>
import TagItem from '@/components/common/TagItem'

export default {
  name: 'SearchType',
  components: {
    TagItem
  },
  directives: {},
  props: {
    typeList: {
      type: Array,
      default: () => []
    },
    currentType: {
      type: String,
      default: 'all'
    }
  },
  data() {
    return {}
  },
  computed: {
    getSearchInputPosition() {
      return this.$store.state.search.inputPosition
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    tagOnClick(typeItem) {
      if (typeItem.type === this.currentType) {
        this.$emit('update', 'all')
      } else {
        this.$emit('update', typeItem.type)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.search-type {
  &-container {
    margin: 36px 0 0 0; // top 36px
    &.fixed {
      min-height: 64px;
      line-height: 64px;
      margin: 0 24px 0 0; // margin right for cancel btn
      .tag-item {
        margin: 8px 24px 8px 0;
        vertical-align: middle;
      }
    }
  }
}

@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {
  .search-type {
    &-container {
      margin: 14px 0 0 0;

      &.fixed {
        min-height: 44px;
        line-height: 44px;
      }
    }
  }
}

</style>
